import { render, staticRenderFns } from "./my-switch.vue?vue&type=template&id=782f44b2&scoped=true"
import script from "./my-switch.vue?vue&type=script&lang=js"
export * from "./my-switch.vue?vue&type=script&lang=js"
import style0 from "./my-switch.vue?vue&type=style&index=0&id=782f44b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782f44b2",
  null
  
)

export default component.exports